import { useState, useCallback } from 'react';
import testService from 'services/testService';

export const useReportGeneration = () => {
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [valuesTestData, setValuesTestData] = useState(null);
  const [songTestData, setSongTestData] = useState(null);
  const [drawingTestData, setDrawingTestData] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [showReport, setShowReport] = useState(false);

  const generateReport = useCallback(async (candidate, showNotification) => {
    if (!candidate) {
      showNotification("Error: No se encontró el candidato", "error");
      return false;
    }

    try {
      setIsGeneratingReport(true);
      showNotification("Generando informe...", "info");
      
      console.log('Candidato encontrado:', candidate.nombre_completo);
      setSelectedCandidate(candidate);
      
      // Show detailed progress
      showNotification("Cargando datos del candidato...", "info");
      
      // Obtener resultados de todos los tests en paralelo para mejor rendimiento
      const [valuesTestResults, songTestResults, drawingTestResults] = await Promise.allSettled([
        testService.obtenerResultadosTestValores(candidate.id_candidato),
        testService.obtenerResultadosTestCanciones(candidate.id_candidato),
        testService.obtenerResultadosTestDibujos(candidate.id_candidato)
      ]);
      
      showNotification("Procesando resultados...", "info");

      // Procesar resultados del test de valores
      if (valuesTestResults.status === 'fulfilled') {
        setValuesTestData(valuesTestResults.value);
      } else {
        console.error('Error obteniendo datos del test de valores:', valuesTestResults.reason);
        throw valuesTestResults.reason;
      }

      // Procesar resultados del test de canciones
      if (songTestResults.status === 'fulfilled') {
        setSongTestData(songTestResults.value);
      } else {
        console.warn('No se pudieron obtener los datos del test de canciones:', songTestResults.reason);
        setSongTestData(null);
      }

      // Procesar resultados del test de dibujos
      if (drawingTestResults.status === 'fulfilled') {
        setDrawingTestData(drawingTestResults.value);
      } else {
        console.warn('No se pudieron obtener los datos del test de dibujos:', drawingTestResults.reason);
        setDrawingTestData(null);
      }
      
      setShowReport(true);
      showNotification("Informe generado para " + candidate.nombre_completo, "success");
      return true;
    } catch (error) {
      console.error('Error obteniendo datos del test de valores:', error);
      showNotification("Error al obtener resultados del test: " + (error.message || "Error desconocido"), "error");
      return false;
    } finally {
      setIsGeneratingReport(false);
    }
  }, []);

  const resetReport = useCallback(() => {
    setShowReport(false);
    setSelectedCandidate(null);
    setValuesTestData(null);
    setSongTestData(null);
    setDrawingTestData(null);
  }, []);

  return {
    selectedCandidate,
    valuesTestData,
    songTestData,
    drawingTestData,
    isGeneratingReport,
    showReport,
    generateReport,
    resetReport
  };
};